import React from 'react';
import DropdownMenu from 'react-dd-menu';
import ReactTooltip from 'react-tooltip';
import 'react-dd-menu/dist/react-dd-menu.css';
import Icon from './Icon';
import { DocumentViewButtonsWrapper } from './styled';
import hasUrlInList from '../utils';
import { DownloadPDFButton } from '../../Icons';
const Buttons = ({ resizeImages, scrollTowards, actualZoom, isDownloadMenuOpen, downloadMenuClose, downloadMenuToggle, translation, documents, handlePrint, isTapped, viewer, completed, isEnterprise, }) => {
    const menuOptions = {
        isOpen: isDownloadMenuOpen,
        align: 'left',
        animAlign: 'center',
        upwards: true,
        close: downloadMenuClose || function () { },
        menuAlign: 'center',
        toggle: (React.createElement("button", { type: "button", onClick: () => downloadMenuToggle() },
            React.createElement(Icon, { name: "icon-download-folder", className: "downloadButton" }))),
    };
    const toolTipOptions = {
        delayShow: 1000,
        className: 'buttons-group col-tooltip',
        effect: 'solid',
    };
    const t = translation;
    const docs = (type) => documents[type] &&
        documents[type].map((item) => item.url && (React.createElement("li", { key: item.id },
            React.createElement("a", { href: item.url, download: true, className: "d-flex" },
                React.createElement(Icon, { name: "icon-file", className: "dd-menu-icon" }),
                item.filename))));
    const signed = () => (React.createElement("li", { key: documents.merged.id },
        React.createElement("a", { href: documents.merged.url, download: true, className: "d-flex" },
            React.createElement(Icon, { name: "icon-file", className: "dd-menu-icon" }),
            documents.merged.filename)));
    const canShowCert = documents.cert && documents.cert.url;
    const canShowMarged = documents.merged && documents.merged.url;
    const canShowSources = documents.sources && hasUrlInList(documents.sources);
    const canShowConverted = viewer && documents.converted && hasUrlInList(documents.converted);
    const canShowCompletedForEnterprise = isEnterprise &&
        completed &&
        documents.converted &&
        hasUrlInList(documents.converted);
    const canShowDownloadButton = documents.zip ||
        canShowCert ||
        canShowMarged ||
        canShowSources ||
        canShowConverted;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    return (React.createElement(DocumentViewButtonsWrapper, { isTapped: isTapped },
        React.createElement("div", { className: "Buttons col" },
            React.createElement("button", { className: "next-page-button hidden-sm-down", "data-tip": t.nextPage, "data-for": "nextPage", onClick: () => scrollTowards(1) },
                React.createElement(Icon, { name: "icon-down" })),
            React.createElement(ReactTooltip, Object.assign({ id: "nextPage" }, toolTipOptions)),
            React.createElement("button", { className: "prev-page-button hidden-sm-down", "data-tip": t.prevPage, "data-for": "prevPage", onClick: () => scrollTowards(-1) },
                React.createElement(Icon, { name: "icon-up" })),
            React.createElement(ReactTooltip, Object.assign({ id: "prevPage" }, toolTipOptions)),
            React.createElement("button", { className: "zoom-in-page-button", "data-tip": t.zoomInPage, "data-for": "zoomInPage", onClick: () => resizeImages(0.1) },
                React.createElement(Icon, { name: "icon-zoom-in" })),
            React.createElement(ReactTooltip, Object.assign({ id: "zoomInPage" }, toolTipOptions, { globalEventOff: isMobile ? 'touchstart' : undefined })),
            React.createElement("button", { className: "zoom-out-page-button", "data-tip": t.zoomOutPage, "data-for": "zoomOutPage", onClick: () => resizeImages(-0.1) },
                React.createElement(Icon, { name: "icon-zoom-out" })),
            React.createElement(ReactTooltip, Object.assign({ id: "zoomOutPage" }, toolTipOptions, { globalEventOff: isMobile ? 'touchstart' : undefined })),
            React.createElement("span", { className: "page-zoom hidden-sm-down" },
                actualZoom,
                "%"),
            React.createElement("button", { className: "print-button hidden-sm-down", "data-tip": t.printPage, "data-for": "printPage", onClick: () => handlePrint() },
                React.createElement(Icon, { name: "icon-print" })),
            React.createElement(ReactTooltip, Object.assign({ id: "printPage" }, toolTipOptions)),
            canShowDownloadButton && (React.createElement(DropdownMenu, Object.assign({}, menuOptions),
                React.createElement("li", { className: "dd-menu-header" },
                    t.downLoadDocuments,
                    React.createElement("button", { className: "menu-toggle-button dd-menu-header-icon dd-item-ignore", onClick: () => downloadMenuToggle() },
                        React.createElement(Icon, { name: "icon-multiply" }))),
                canShowMarged && (React.createElement("li", { className: "dd-menu-subheader d-merged" }, t.signedDocuments)),
                canShowMarged && signed(),
                canShowCert && (React.createElement("li", { className: "dd-menu-subheader d-cert" }, t.certificate)),
                canShowCert && (React.createElement("li", null,
                    React.createElement("a", { href: documents.cert.url, download: true, className: "d-flex" },
                        React.createElement(Icon, { name: "icon-file", className: "dd-menu-icon" }),
                        documents.cert.filename))),
                canShowSources && (React.createElement("li", { className: "dd-menu-subheader d-sources" }, t.sourceDocuments)),
                canShowSources && docs('sources'),
                canShowConverted && (React.createElement("li", { className: "dd-menu-subheader d-sources" }, t.sourceDocuments)),
                canShowConverted && docs('converted'),
                React.createElement("li", { role: "separator", className: "separator" }),
                documents.zip && (React.createElement("li", { className: "d-zip" },
                    React.createElement("a", { href: documents.zip, download: true, className: "d-flex" },
                        React.createElement(Icon, { name: "icon-download-folder_2", className: "dd-menu-icon" }),
                        React.createElement("span", null, t.downloadAll)))))),
            canShowCompletedForEnterprise &&
                documents.converted.map((item) => (React.createElement("a", { href: item.url, download: true, className: "d-flex" },
                    React.createElement(DownloadPDFButton, null)))))));
};
export default Buttons;
